<template>
  <div>
    <supplier-product-search
      @searchList="searchList"
      :categoryType="categoryType"
    ></supplier-product-search>
    <v-data-table
      :loading="loading"
      :items="items"
      :headers="headers"
      class="elevation-1"
      disable-pagination
      hide-default-footer
      show-select
      v-model="selected"
      checkbox-color="primary"
      :single-select="true"
    >
      <template v-slot:[`item.mainImage`]="{ item }">
        <v-img
          :src="item.mainImage.thumbnailFileUrl"
          width="80"
          height="45"
          :alt="item.mainImage.alt"
        ></v-img>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span>
          {{ getStatusTitle(item.status) }}
        </span>
      </template>
      <template v-slot:[`item.hasPrice`]="{ item }">
        <!-- <span>
          {{ item.hasPrice ? 'دارد' : '-' }}
        </span> -->
        <v-btn small v-if="item.hasPrice" @click="showPriceDetails(item)"
          ><v-icon>mdi mdi-book</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.createdTimeUtc`]="{ item }">
        <span>
          {{ item.createdTimeUtc | moment }}
        </span>
      </template>
      <template v-slot:[`item.operation`]="{ item }">
        <v-tooltip bottom v-if="item.status == 'Draft'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              color="primary"
              @click="postRequestConfirm(item)"
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi mdi-send</v-icon>
            </v-btn>
          </template>
          <span>درخواست تایید</span>
        </v-tooltip>

        <v-btn
          icon
          small
          color="primary"
          @click="showSupplierProductInSite(item)"
          v-if="item.adminConfirmed"
        >
          <v-icon color="blue" small>mdi-web</v-icon></v-btn
        >
        <v-tooltip bottom v-if="item.status != 'Archive'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              color="error"
              @click="postArchive(item)"
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi mdi-archive</v-icon>
            </v-btn>
          </template>
          <span>بایگانی</span>
        </v-tooltip>
        <v-btn icon color="primary" @click="getSupplierProductByIdForEdit(item)"
          ><v-icon>mdi-lead-pencil</v-icon></v-btn
        >
        <v-btn
          icon
          small
          color="primary"
          @click="showSupplierProductDetail(item)"
        >
          <v-icon color="blue" small>mdi-eye</v-icon></v-btn
        >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              color="error"
              @click="registerPrice(item)"
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi mdi-currency-usd</v-icon>
            </v-btn>
          </template>
          <span>ثبت قیمت</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <div class="text-center mt-2">
      <v-row>
        <v-col cols="12" sm="4" md="2">
          <v-select
            outlined
            dense
            v-model="itemsPerPage"
            :items="[5, 10, 20]"
            label="تعداد نمایش در صفحه"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="8" md="10">
          <v-pagination
            circle
            v-model="pageNumber"
            :length="pageCount"
            :total-visible="7"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
    <v-dialog
      v-model="showIProductPriceModalForm"
      max-width="800"
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar flat dark color="primary" max-height="80px" height="70px">
          ثبت قیمت محصولات و خدمات
          <v-spacer></v-spacer>
          <v-btn icon color="white" @click="showIProductPriceModalForm = false">
            <v-icon>mdi mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <SupplierProductPriceForm
            @closePriceModal="closeModal"
            :supplierProductId="supplierProductId"
            :minimumOrderVolume="minimumOrderVolume"
            :selectedSupplierProduct="selectedSupplierProduct"
          >  
          </SupplierProductPriceForm>
        </v-card-text>

        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>
     <v-dialog
      v-model="showIProductPriceDetailsModal"
      max-width="450"
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar flat dark color="primary" >
          مشاهده آخرین قیمت محصولات و خدمات : {{ supplierProductName }}
          <v-spacer></v-spacer>
          <v-btn icon color="white" @click="showIProductPriceDetailsModal = false">
            <v-icon>mdi mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <SupplierProductPriceDetails
            @closePriceModal="closePriceModal()"
            :supplierProductId="supplierProductId"
         
          >
          </SupplierProductPriceDetails>
        </v-card-text>

        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>
 </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const supplierProductRepository = RepoFactory.get('supplierProduct');
import Helper from '@/core/helpers';
import SupplierProductSearch from './SupplierProductSearch.vue';
import SupplierProductPriceForm from './SupplierProductPriceForm.vue';
import SupplierProductPriceDetails from './SupplierProductPriceDetails.vue';
const enumsRepository = () => RepoFactory.get('enums');
export default {
  components: {
    SupplierProductSearch,
    SupplierProductPriceForm,
    SupplierProductPriceDetails,
  },
  props: {
    categoryType: {
      type: String,
      default: null,
    },
    categoryTypeDisplayName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      minimumOrderVolume:null,
      showIProductPriceModalForm: false,
      showIProductPriceDetailsModal:false,
      supplierProductId: null,
      supplierProductName:"",
      loading: false,
      items: [],
      itemsPerPage: 10,
      pageNumber: 1,
      pageCount: 0,
      selected: [],
      searchFilterParams: null,
      headers: [
        { text: 'تصویر شاخص ', value: 'mainImage' },
        { sortable: true, text: 'نام ', value: 'name' },
        { sortable: true, text: 'وضعیت', value: 'status' },
        { sortable: true, text: 'قیمت', value: 'hasPrice' },
        { sortable: true, text: 'زمان ثبت', value: 'createdTimeUtc' },
        {
          text: 'عملیات',
          value: 'operation',
          align: 'left',
        },
      ],
      statusItem: [],
      selectedSupplierProduct: null,
    };
  },
  computed: {
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
  },
  created() {
    if (this.categoryType == 'Product') {
      if (
        this.$store.getters.ProductPageNumber != null &&
        this.$store.getters.ProductItemsPerPage != null
      ) {
        this.pageNumber = this.$store.getters.ProductPageNumber;
        this.itemsPerPage = this.$store.getters.ProductItemsPerPage;
      } else {
        this.pageNumber = 1;
        this.itemsPerPage = 10;
      }
      if (this.$store.getters.ProductSelectedItem != null) {
        this.selected = [];
        this.selected.push(this.$store.getters.ProductSelectedItem);
      }
    } else if (this.categoryType == 'IndustrialService') {
      if (
        this.$store.getters.IndustrialServicePageNumber != null &&
        this.$store.getters.IndustrialServiceItemsPerPage != null
      ) {
        this.pageNumber = this.$store.getters.IndustrialServicePageNumber;
        this.itemsPerPage = this.$store.getters.IndustrialServiceItemsPerPage;
      } else {
        this.pageNumber = 1;
        this.itemsPerPage = 10;
      }
      if (this.$store.getters.IndustrialServiceSelectedItem != null) {
        this.selected = [];
        this.selected.push(this.$store.getters.IndustrialServiceSelectedItem);
      }
    } else if (this.categoryType == 'ConsultingService') {
      if (
        this.$store.getters.ConsultingServicePageNumber != null &&
        this.$store.getters.ConsultingServiceItemsPerPage != null
      ) {
        this.pageNumber = this.$store.getters.ConsultingServicePageNumber;
        this.itemsPerPage = this.$store.getters.ConsultingServiceItemsPerPage;
      } else {
        this.pageNumber = 1;
        this.itemsPerPage = 10;
      }
      if (this.$store.getters.ConsultingServiceSelectedItem != null) {
        this.selected = [];
        this.selected.push(this.$store.getters.ConsultingServiceSelectedItem);
      }
    } else if (this.categoryType == 'ElectronicDocument') {
      if (
        this.$store.getters.ElectronicDocumentPageNumber != null &&
        this.$store.getters.ElectronicDocumentItemsPerPage != null
      ) {
        this.pageNumber = this.$store.getters.ElectronicDocumentPageNumber;
        this.itemsPerPage = this.$store.getters.ElectronicDocumentItemsPerPage;
      } else {
        this.pageNumber = 1;
        this.itemsPerPage = 10;
      }
      if (this.$store.getters.ElectronicDocumentSelectedItem != null) {
        this.selected = [];
        this.selected.push(this.$store.getters.ElectronicDocumentSelectedItem);
      }
    }
    this.getSupplierProducts(this.pageNumber, this.itemsPerPage);
    this.getStatusEnum();
  },

  watch: {
    pageNumber(after, before) {
      if (this.categoryType == 'Product') {
        this.$store.commit('setProductPageNumber', after);
        this.$store.commit('setProductItemsPerPage', this.itemsPerPage);
      } else if (this.categoryType == 'IndustrialService') {
        this.$store.commit('setIndustrialServicePageNumber', after);
        this.$store.commit(
          'setIndustrialServiceItemsPerPage',
          this.itemsPerPage
        );
      } else if (this.categoryType == 'ConsultingService') {
        this.$store.commit('setConsultingServicePageNumber', after);
        this.$store.commit(
          'setConsultingServiceItemsPerPage',
          this.itemsPerPage
        );
      } else if (this.categoryType == 'ElectronicDocument') {
        this.$store.commit('setElectronicDocumentPageNumber', after);
        this.$store.commit(
          'setElectronicDocumentItemsPerPage',
          this.itemsPerPage
        );
      }
      this.getSupplierProducts(after, this.itemsPerPage);
    },
    itemsPerPage(after, before) {
      if (this.categoryType == 'Product') {
        this.$store.commit('setProductPageNumber', 1);
        this.$store.commit('setProductItemsPerPage', after);
      } else if (this.categoryType == 'IndustrialService') {
        this.$store.commit('setIndustrialServicePageNumber', 1);
        this.$store.commit('setIndustrialServiceItemsPerPage', after);
      } else if (this.categoryType == 'ConsultingService') {
        this.$store.commit('setConsultingServicePageNumber', 1);
        this.$store.commit('setConsultingServiceItemsPerPage', after);
      } else if (this.categoryType == 'ElectronicDocument') {
        this.$store.commit('setElectronicDocumentPageNumber', 1);
        this.$store.commit('setElectronicDocumentItemsPerPage', after);
      }
      this.getSupplierProducts(this.pageNumber, after);
    },
    merchantId() {
      this.pageNumber = 1;
      this.getSupplierProducts(1, this.itemsPerPage);
    },
    categoryType(after, before) {
      this.pageNumber = 1;
      this.getSupplierProducts(1, this.itemsPerPage);
    },
  },
  methods: {
    closeModal() {
      this.showIProductPriceModalForm = false;
    },
    closePriceModal() {
       this.showIProductPriceDetailsModal = false;
    },
    searchList(searchParams) {
      this.pageNumber = 1;
      this.searchFilterParams = searchParams;
      this.getSupplierProducts(this.pageNumber, this.itemsPerPage);
    },
    getStatusTitle(advertisementStatus) {
      const item = this.statusItem.find(
        (el) => el.title === advertisementStatus
      );
      if (item) {
        return item.displayName;
      }
      return '';
    },
    getStatusEnum() {
      enumsRepository()
        .getEnum('SupplierProductStatus', this.productBaseUrl)
        .then((res) => {
          this.statusItem = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    showSupplierProductInSite(item) {
      this.setSelectedItem(item);
      let str = item.name.replace(/\s+/g, '-').toLowerCase();
      let pageUrl =
        this.$store.getters.taksaanUrl + '/products/' + item.id + '/' + str;
      window.open(pageUrl, '_blank');
    },
    showSupplierProductDetail(item) {
      this.setSelectedItem(item);
      this.$router.push({
        path: `/supplier-products/${this.categoryType}/detail/${item.id}?tab=Info`,
      });
    },
    getSupplierProductByIdForEdit(item) {
      this.setSelectedItem(item);
      this.$router.push({
        path: `/supplier-products/${this.categoryType}/detail/${item.id}?tab=Edit`,
      });
    },
    getSupplierProducts(pageNumber = 1, itemsPerPage = 10) {
      if (this.merchantId) {
        const loader = this.$loading.show();
        this.loading = true;
        this.pageNumber = pageNumber;
        this.itemsPerPage = itemsPerPage;
        if (this.categoryType == 'Product') {
          this.searchFilterParams =
            this.$store.getters.ProductSearchFilterParams;
        } else if (this.categoryType == 'IndustrialService') {
          this.searchFilterParams =
            this.$store.getters.IndustrialServiceSearchFilterParams;
        } else if (this.categoryType == 'ConsultingService') {
          this.searchFilterParams =
            this.$store.getters.ConsultingServiceSearchFilterParams;
        } else if (this.categoryType == 'ElectronicDocument') {
          this.searchFilterParams =
            this.$store.getters.ElectronicDocumentSearchFilterParams;
        }
        let params = {
          PageNumber: pageNumber,
          ItemsPerPage: itemsPerPage,
          categoryType: this.categoryType,
          ...this.searchFilterParams,
        };
        supplierProductRepository
          .getSupplierProducts(
            this.productBaseUrl,
            { MerchantId: this.merchantId },
            params
          )
          .then((res) => {
            this.pageCount = Math.ceil(res.data.totalCount / itemsPerPage);
            this.items = res.data.list;
            this.loading = false;
            loader.hide();
          })
          .catch((error) => {
            this.loading = false;
            loader.hide();
            Helper.handleErrors(error, this);
          });
      }
    },
    postRequestConfirm(item) {
      this.setSelectedItem(item);
      this.$dialog.warning({
        text: `آیا از درخواست تایید   <span class="red--text">${item.name}</span> اطمینان دارید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              const loader = this.$loading.show();
              supplierProductRepository
                .postRequestConfirm(item.id, this.productBaseUrl, {
                  MerchantId: this.merchantId,
                })
                .then(() => {
                  this.getSupplierProducts();
                  this.$dialog.message.success(
                    'با موفقیت درخواست تایید ارسال گردید',
                    {
                      position: 'top-left',
                    }
                  );
                  loader.hide();
                })
                .catch((error) => {
                  Helper.handleErrors(error, this);
                  loader.hide();
                });
            },
          },
        },
      });
    },
    postArchive(item) {
      this.setSelectedItem(item);
      this.$dialog.warning({
        text: `در صورت بایگانی   <span class="red--text">${item.name}</span> اطلاعات در سایت نمایش داده نخواهد شد و قابل جستجو هم نخواهد بود آیا مطمئن هستید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              const loader = this.$loading.show();
              supplierProductRepository
                .postArchive(item.id, this.productBaseUrl, {
                  MerchantId: this.merchantId,
                })
                .then(() => {
                  this.getSupplierProducts();
                  this.$dialog.message.success('با موفقیت بایگانی گردید', {
                    position: 'top-left',
                  });
                  loader.hide();
                })
                .catch((error) => {
                  Helper.handleErrors(error, this);
                  loader.hide();
                });
            },
          },
        },
      });
    },
    setSelectedItem(item) {
      this.selected = [];
      if (this.categoryType == 'Product') {
        this.$store.commit('setProductSelectedItem', item);
        this.selected.push(this.$store.getters.ProductSelectedItem);
      } else if (this.categoryType == 'IndustrialService') {
        this.$store.commit('setIndustrialServiceSelectedItem', item);
        this.selected.push(this.$store.getters.IndustrialServiceSelectedItem);
      } else if (this.categoryType == 'ConsultingService') {
        this.$store.commit('setConsultingServiceSelectedItem', item);
        this.selected.push(this.$store.getters.ConsultingServiceSelectedItem);
      } else if (this.categoryType == 'ElectronicDocument') {
        this.$store.commit('setElectronicDocumentSelectedItem', item);
        this.selected.push(this.$store.getters.ElectronicDocumentSelectedItem);
      }
    },
    registerPrice(item) {
      this.showIProductPriceModalForm = true;
      this.supplierProductId = item.id;
      this.getSupplierProductById(item.id)
      this.minimumOrderVolume = item.minimumOrderVolume;
    },
    showPriceDetails(item) {
      this.showIProductPriceDetailsModal = true;
      this.supplierProductId = item.id;
      this.supplierProductName=item.name
    },
    getSupplierProductById(id) {
      const loader = this.$loading.show();
      supplierProductRepository
        .getSupplierProductById(id, this.productBaseUrl, {})
        .then((res) => {
          console.log('result');
          console.log(res);
          loader.hide();
          this.selectedSupplierProduct = res.data;
         })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
  },
};
</script>

<style scoped></style>
